export default __webpack_public_path__ + "static/3-85d36f2b2701c8fdab4ec2d65202b458.jpeg";